import { Navigate, useRoutes } from "react-router-dom";

import { AppLink, Captcha, Landing } from "@/features/misc";
import { useAuth } from "@/libs/auth";

import { protectedRoutes } from "./protected";
import { publicRoutes } from "./public";
import { RouteConstant } from "./routeConstant";
import { useGetAppDataMutation } from "@/features/auth";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { UserSpinner } from "@/components/Common";
import { useEffect } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";

export const AppRoutes = () => {
  const { isLoggedIn } = useAuth();
  const [getAppData] = useGetAppDataMutation();
  const { googleApiKey } =
    useSelector((state: RootState) => state.appData.appData) ?? {};

  useEffect(() => {
    getAppData();
  }, []);

  const commonRoutes = [
    { path: RouteConstant.Captcha, element: <Captcha /> },
    { path: RouteConstant.Landing, element: <Landing /> },
    { path: RouteConstant.AppLink, element: <AppLink /> },
    { path: "*", element: <Navigate to={RouteConstant.Landing} /> },
  ];

  const routes = isLoggedIn ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  if (!googleApiKey) {
    return <UserSpinner />;
  }

  return <APIProvider apiKey={googleApiKey}>{element}</APIProvider>;
};
